import React from 'react';
import { Typography, Card, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import GavelIcon from '@mui/icons-material/Gavel';
import { useNavigate } from 'react-router-dom';

const StyledGavelIcon = styled(GavelIcon)(
  {
    position: 'relative',
    top: 0,
    left: 0,
    fontSize: 32,
    color: 'var(--teal_brighter)',
    filter: 'drop-shadow(0 2px 6px #000a)',
  }
);

type OrderBannerProps = {
  latestOrder: {
    title: string;
    summary: string;
  } | null;
};

const OrderBanner: React.FC<OrderBannerProps> = ({ latestOrder }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate('/orders');
  };

  return (
    <Card
      onClick={handleClick}
      sx={{
        backgroundColor: 'var(--backgroundcolor2)',
        borderRadius: 2,
        boxShadow: 3,
        mb: 3,
        cursor: 'pointer',
        position: 'relative',
        transition: 'box-shadow .2s',
        '&:hover': { boxShadow: 8, background: 'rgba(0,206,187,0.08)' },
      }}
    >
      <Box sx={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 1 }}>
        <Box sx={{ display: 'inline-block' }}>
          <StyledGavelIcon sx={{ transform: 'rotate(-25deg)', margin: '0 12px 0 0' }} />
        </Box>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 'bold',
            color: 'var(--teal_brighter)',
            textAlign: 'center',
            position: 'relative',
            zIndex: 1,
          }}
        >
          Latest DOJ Order
        </Typography>
        <Box sx={{ display: 'inline-block' }}>
          <StyledGavelIcon sx={{ transform: 'rotate(25deg) scaleX(-1)', margin: '0 0 0 12px' }} />
        </Box>
      </Box>
      <Typography
        variant="h6"
        sx={{
          mt: 1,
          fontWeight: 'bold',
          color: 'white',
          textAlign: 'center',
        }}
      >
        {latestOrder?.title || 'No Title Available'}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: 1 }}>
        <Typography
          variant="body2"
          sx={{ color: 'white', fontWeight: 500, fontSize: '0.85rem', textAlign: 'center', mr: 1 }}
        >
          {latestOrder?.summary || 'No Summary Available'}
        </Typography>
        <span style={{ color: 'var(--teal_brighter)', fontWeight: 700, fontSize: '1.1em' }}>→</span>
      </Box>
    </Card>
  );
};

export default OrderBanner;
